module.exports = __webpack_public_path__ + "img/640.3218e2d1.jpg";